export const isByTagTarget = target => 'byTag' in target;